// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueCookie from 'vue-cookie'
import VueI18n from 'vue-i18n'
import en from './translations/en'
import de from './translations/de'
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';


if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://5b0659e75ae8443c97c9e06fc63865c1@sentry.io/1476351',
    integrations: [new Integrations.Vue({Vue, attachProps: true})],
  });
}

Vue.config.productionTip = false

Vue.use(VueCookie)
Vue.use(VueI18n)

const messages = {
  "en": en,
  "de": de
}

const i18n = new VueI18n({
  locale: 'de',
  messages
})

toastr.options = {
  "positionClass": "toast-bottom-right",
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js